import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Params, Router } from '@angular/router';
import moment from 'moment';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { debounceTime, delay, map, takeUntil, tap } from 'rxjs/operators';
import { ILedger, ILedgerCriteria } from 'src/app/accounts/ledger/ledger.interface';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { DeactivateComponent } from 'src/app/shared/components/deactivate/deactivate.component';
import { ReactivateComponent } from 'src/app/shared/components/reactivate/reactivate.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow, IState } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';
import { IBusinessSegment, IBusinessSegmentCriteria } from '../../business-segment/business-segment.interface';
import { ICharge, IChargeCriteria } from '../../charge/charge.interface';
import { IGst } from '../../gst/gst.interface';
import { GstUpdateFormComponent } from '../gst-update-form/gst-update-form.component';
import { IMapChargeBusinessSegment, IMapChargeBusinessSegmentCriteria } from '../map-charge-to-business-segment.interface';
import { MapSegmentChargeDetailComponent } from '../map-segment-charge-detail/map-segment-charge-detail.component';

@Component({
    selector: 'app-map-charge-to-business-segment-form',
    templateUrl: './map-charge-to-business-segment-form.component.html',
    styleUrls: ['./map-charge-to-business-segment-form.component.less'],
    standalone: false
})
export class MapChargeToBusinessSegmentFormComponent implements OnInit,AfterViewChecked {

  constructor(private formBuilder:FormBuilder,private service:DataService,
              private logger:NGXLogger,private permissionService:PermissionService,
              private activatedRoute: ActivatedRoute,private router:Router,
              private utilityService:UtilityService,
              private dailog:MatDialog,private changerDetectorRef:ChangeDetectorRef) { }

  legderCriteria:ILedgerCriteria={};
  segmentCriteria:IBusinessSegmentCriteria={}; 
  mapChargeSegmentForm:FormGroup;
  filteredSegments:ReplaySubject<IBusinessSegment[]> = new ReplaySubject<IBusinessSegment[]>(1);
  segmentSearchCtrl = this.formBuilder.control('');
  filteredStates:ReplaySubject<IState[]> = new ReplaySubject<IState[]>(1);
  stateSearchCtrl = this.formBuilder.control('');
  filteredPreviousEntries:ReplaySubject<IMapChargeBusinessSegment[]> = new ReplaySubject<IMapChargeBusinessSegment[]>(1);
  previousEntrySearchCtrl = this.formBuilder.control('');
  filteredLedgers:ReplaySubject<ILedger[]> = new ReplaySubject<ILedger[]>(1);
  ledgerSearchCtrl = this.formBuilder.control('');
  filteredLocalExpenseLedgers:ReplaySubject<ILedger[]> = new ReplaySubject<ILedger[]>(1);
  localExpenseLedgerSearchCtrl = this.formBuilder.control('');
  filteredOverseasIncomeLedgers:ReplaySubject<ILedger[]> = new ReplaySubject<ILedger[]>(1);
  overseasIncomeLedgerSearchCtrl = this.formBuilder.control('');
  filteredOverseasExpenseLedgers:ReplaySubject<ILedger[]> = new ReplaySubject<ILedger[]>(1);
  overseasExpenseLedgerSearchCtrl = this.formBuilder.control('');
  filteredSezIncomeLedgers:ReplaySubject<ILedger[]> = new ReplaySubject<ILedger[]>(1);
  sezIncomeLedgerSearchCtrl = this.formBuilder.control('');
  previousEntries:any;
  segments:any;
  states:any;
  ledgers:any;
  data:any;
  taxableList=this.utilityService.getYesNoList();
  chargeTypeMechanismList:any;
  chargeCriteria:IChargeCriteria={}
  filteredCharges=new BehaviorSubject<ICharge[]>([]);
  filteredSAC=new BehaviorSubject<IGst[]>([]);
  charges:any;
  gstList:any;
  onDestroy = new Subject<void>();
  reactivatePermission:boolean=false;
  deactivatePermission:boolean=false;
  editPermission:boolean=false;
  addPermission:boolean=false;
  disableSubmit:boolean=false;
  resLocalExpenseDetails:any;
  resLocalIncomeDetails:any;
  resOverseasExpenseDetails:any;
  resOverseasIncomeDetails:any;
  resSezIncomeDetails:any;
  mapChargeBusinessSegmentData:any;
  isEditedData:boolean=false;
  showStatus:string;
  showDeactivateToggle=false;
  showReactivateToggle=false;
  checked:boolean=false;
  @Input() searching: boolean = false;
  criteria:IMapChargeBusinessSegmentCriteria={};
  viewLog = this.formBuilder.control(false);
  sezDetailColumns=['chargeCode','chargeName','taxable','chargeTypeMechanism','sacCode','sacName','igst','gstWef','deactivated','updateGst','action'];
  sezDetailsDataSource=new BehaviorSubject<AbstractControl[]>([]);
  @ViewChild('localExpenseDetails') localExpenseDetailsComponent:MapSegmentChargeDetailComponent;
  @ViewChild('localIncomeDetails') localIncomeDetailsComponent:MapSegmentChargeDetailComponent;
  @ViewChild('overseasExpenseDetails') overseasExpenseDetailsComponent:MapSegmentChargeDetailComponent;
  @ViewChild('overseasIncomeDetails') overseasIncomeDetailsComponent:MapSegmentChargeDetailComponent;

  ngOnInit(): void {
    this.viewLog.setValue(false);
    this.getAllPermissions();
    this.getChargeTypeMechanism();
    this.initializeForm();
    this.filterStates();
    this.filterLedgers();
    this.filterSegments();
    this.filterPreviousEntries();
    this.getCharges();
    this.getGstList();
    this.getStates();
    this.getSegments();
    this.getLedgers();
    this.getPreviousEntries();
    this.fetchParams();
  }

  private fetchParams(){
    this.activatedRoute.params.subscribe(
      (param:Params) => {
        if(+param['id']){
          this.id.setValue(+param['id']);
          this.getMapChargeBusinessSegmentById();
        }
      }
    )
  }

  private initializeForm(): void {
    this.mapChargeSegmentForm = this.formBuilder.group({
      id:[],
      parentId:[],
      previousEntryId:[],
      segmentId:[null,[Validators.required]],
      stateId:[null,[Validators.required]],
      localIncomeDetails:this.formBuilder.array([]),
      localIncomeLedgerId: [null],
      localExpenseLedgerId: [null],
      localExpenseDetails:this.formBuilder.array([]),
      overseasIncomeLedgerId: [null],
      overseasIncomeDetails:this.formBuilder.array([]),
      overseasExpenseLedgerId: [null],
      overseasExpenseDetails:this.formBuilder.array([]),
      sezIncomeLedgerId: [null],
      sezIncomeDetails: this.formBuilder.array([]),
      showLocalExpenseDetails:[false],
      showLocalIncomeDetails:[false],
      showOverseasIncomeDetails:[false],
      showOverseasExpenseDetails:[false],
      showSezIncomeDetails:[false],
      status:[],
      active:[],
    });
    this.sezDetailsDataSource.next(this.sezIncomeDetails.controls);
  }

  private chargeForm(data?:any) {
    let form= this.formBuilder.group({
      id:[data?data.id:null],
      chargeId:[data?data.chargeId:null,[Validators.required]],
      chargeName:[data?data.chargeName:null],
      taxable:[data?data.taxable:null, [Validators.required]],
      chargeTypeMechanism:[data?data.chargeTypeMechanism:null, [Validators.required]],
      igst:[data?data.igst:null, [Validators.required,Validators.pattern('^[0-9.]+$')]],
      deactivated:[data?data.deactivated:false],
      chargeList:[this.charges],
      chargeSearch:[],
      sacId:[data?data.sacId:null,[Validators.required]],
      sacName:[data?data.sacName:null],
      sacList:[this.gstList],
      sacSearch:[],
      gstWef:[data?data.gstWef:null,[Validators.required]],
      gstWet:[data?data.gstWet:null],
      activeDetail:[data?data.activeDetail:true],
      show:[data?data.show:true],
    });
    this.searchValueChangeInFormArray(form,this.filteredCharges,'chargeSearch','chargeList');
    this.searchValueChangeInFormArray(form,this.filteredSAC,'sacSearch','sacList');
    return form;
  }

  public searchValueChangeInFormArray(form:any,observableName:any,searchControlName:any,selectListControlName:any){
    form.get(searchControlName).valueChanges.subscribe((searchText) => {
      observableName.subscribe((items) => {
        if (searchText) {
          form.get(selectListControlName).setValue(
            items.filter((item) => item.name.toLowerCase().includes(searchText.toLowerCase()) ||
                                      item.code.toLowerCase().includes(searchText.toLowerCase())),
          );
        } else {
          form.get(selectListControlName).setValue(items);
        }
      });
    });
  }

  removeChargeField(index:number){
    this.sezIncomeDetails.removeAt(index);
    this.sezDetailsDataSource.next(this.sezIncomeDetails.controls);
  }

  addChargeField(item?:any){
    if(!item){
      this.sezIncomeDetails.push(this.chargeForm());
      this.sezDetailsDataSource.next(this.sezIncomeDetails.controls);
      return;  
    }
    if(item.invalid){
      item.markAllAsTouched();
      return;
    }
    this.sezIncomeDetails.push(this.chargeForm());
    this.sezDetailsDataSource.next(this.sezIncomeDetails.controls);
  }

  checkChargeDisableCondition(c:any){
    return (_.findWhere(this.sezIncomeDetails.value,{chargeId:c.parentId})) || (c.status!='APPROVED')?true:false;
  }

  deactivateChanged(item:any,event:any){
    if(event.checked){
      item.get('gstWet').reset();
      let index=_.findIndex(this.sezIncomeDetails.value,{id:null});
      if(index>-1){
        this.sezIncomeDetails.removeAt(index);
      }
      this.sezDetailsDataSource.next(this.sezIncomeDetails.controls);
    } 
  }

  chargedChanged(item:any,i:number){
    let chargeById=_.findWhere(this.charges,{id:item.get('chargeId').value});
    item.get('chargeName').setValue(chargeById?.name);
  }

  sacChanged(item:any,i:number){
    let sacById=_.findWhere(this.gstList,{id:item.get('sacId').value});
    item.get('sacName').setValue(sacById?.name);
  }

  dateChangeEvent(event:any,item:any){
    let formattedDate=moment(event.value).utc(true).toDate();
    item.get('gstWef').setValue(formattedDate);
  }

  openGstEditForm(chargeId?:number){
    let details=_.where(this.sezIncomeDetails.value,{chargeId:chargeId});
    let data={
      chargeDetails:details,
      name:'SEZ INCOME'
    }
    const dailogRef=this.dailog.open(GstUpdateFormComponent,{
      data:data,
      maxWidth:"950px",
      maxHeight:"500px"
    });

    dailogRef.afterClosed().subscribe(dailogResult => {
      if(dailogResult==false){
        return;
      } else {
        if(this.sezIncomeDetails.length > 0){
          dailogResult.forEach(element => {
            if(element.id){
              let index = _.findIndex(this.sezIncomeDetails.value, {id:element.id});
              this.sezIncomeDetails.at(index).get('gstWet').setValue(element.gstWet);
              this.sezIncomeDetails.at(index).get('activeDetail').setValue(false);
            } else {
              this.sezIncomeDetails.push(this.chargeForm(element));
            }
          })
        }
        this.sezDetailsDataSource.next(this.sezIncomeDetails.controls);
      }
    })
  }

  public previousValueChange(){
    if(this.previousEntryId.value!=0){
      let previousEntry=_.findWhere(this.previousEntries, {parentId: this.previousEntryId.value});
      let previousEntryById={ ...previousEntry };
      if(previousEntryById){
        previousEntryById.id=null;
        previousEntryById.status=null;
        previousEntryById.active=null;
        previousEntryById.parentId=null;
        previousEntryById.previousEntryId=this.previousEntryId.value;
        this.mapChargeSegmentForm.patchValue(previousEntryById);
        this.resLocalIncomeDetails= previousEntryById.localIncomeDetails;
        this.resLocalExpenseDetails= previousEntryById.localExpenseDetails;
        this.resOverseasIncomeDetails= previousEntryById.overseasIncomeDetails;
        this.resOverseasExpenseDetails= previousEntryById.overseasExpenseDetails;
        this.patchSezIncomeDetails(previousEntryById.sezIncomeDetails);
      }
    } else {
      this.mapChargeSegmentForm.reset();
      this.resLocalIncomeDetails= 'clear';
      this.resLocalExpenseDetails= 'clear';
      this.resOverseasIncomeDetails= 'clear';
      this.resOverseasExpenseDetails= 'clear';
    }
  }

  onButtonToggleChange(fieldName:string){
    fieldName=='showOverseasExpenseDetails'?this.showOverseasExpenseDetails.setValue(true):this.showOverseasExpenseDetails.setValue(false);
    fieldName=='showOverseasIncomeDetails'?this.showOverseasIncomeDetails.setValue(true):this.showOverseasIncomeDetails.setValue(false);
    fieldName=='showLocalExpenseDetails'?this.showLocalExpenseDetails.setValue(true):this.showLocalExpenseDetails.setValue(false);
    fieldName=='showLocalIncomeDetails'?this.showLocalIncomeDetails.setValue(true):this.showLocalIncomeDetails.setValue(false);
    fieldName=='showSezIncomeDetails'?this.showSezIncomeDetails.setValue(true):this.showSezIncomeDetails.setValue(false);
  }

  filterStates() {
    this.stateSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.states) { return []; }
          if(!search) { this.filteredStates.next(this.states); }
          return this.states.filter(state => state.name.toLowerCase().indexOf(search.toLowerCase()) > -1 || 
                                               state.code.toLowerCase().indexOf(search.toLowerCase()) > -1);
        }),
        delay(200)
      )
      .subscribe(filteredStates=> {
        this.searching = false;
        this.filteredStates.next(filteredStates);
      },
      error => { this.searching = false; });
  }

  filterPreviousEntries() {
    this.previousEntrySearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.previousEntries) { return []; }
          if(!search) { this.filteredPreviousEntries.next(this.previousEntries); }
          return this.previousEntries.filter(state => state.name.toLowerCase().indexOf(search.toLowerCase()) > -1 || 
                                               state.code.toLowerCase().indexOf(search.toLowerCase()) > -1);
        }),
        delay(200)
      )
      .subscribe(filteredEntries=> {
        this.searching = false;
        this.filteredPreviousEntries.next(filteredEntries);
      },
      error => { this.searching = false; });
  }

  filterSegments() {
    this.segmentSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.segments) { return []; }
          if(!search) { this.filteredSegments.next(this.segments); }
          return this.segments.filter(segment => segment.name.toLowerCase().indexOf(search.toLowerCase()) > -1 || 
                                               segment.code.toLowerCase().indexOf(search.toLowerCase()) > -1);
        }),
        delay(200)
      )
      .subscribe(filteredSegments=> {
        this.searching = false;
        this.filteredSegments.next(filteredSegments);
      },
      error => { this.searching = false; });
  }

  filterLedgers() {
    this.ledgerSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.ledgers) { return []; }
          if(!search) { this.filteredLedgers.next(this.ledgers); }
          return this.ledgers.filter(ledger => ledger.name.toLowerCase().indexOf(search.toLowerCase()) > -1 || 
                                               ledger.code.toLowerCase().indexOf(search.toLowerCase()) > -1);
        }),
        delay(200)
      )
      .subscribe(filteredLedgers=> {
        this.searching = false;
        this.filteredLedgers.next(filteredLedgers);
      },
      error => { this.searching = false; });
  }

  openDailog(message?:string)
  {
    const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
        data:message,
        maxWidth:"300px",
        maxHeight:"150px"
      });

    dailogRef.afterClosed().subscribe(dailogResult => {
      this.logger.info('result',dailogResult);
        if(dailogResult===false){
          return;
        }
        else {
          if(!this.isEditedData) {
            this.logger.info('result after true edi',this.isEditedData);
            this.router.navigate([APP_ROUTES.MAP_CHARGE_TO_BUSINESS_SEGMENT_LIST]);
          }
          else {
            this.logger.info('result after true',this.isEditedData);
            this.saveMapChargeToBusinessSegment();
          }
        }
    })
  }

  onSave(){
    this.mapChargeSegmentForm.markAllAsTouched();
    this.localIncomeDetailsComponent.chargeDetailForm.markAllAsTouched();
    this.localExpenseDetailsComponent.chargeDetailForm.markAllAsTouched();
    this.overseasIncomeDetailsComponent.chargeDetailForm.markAllAsTouched();
    this.overseasExpenseDetailsComponent.chargeDetailForm.markAllAsTouched();
    this.data={...this.mapChargeSegmentForm.value,
                localIncomeDetails:this.localIncomeDetailsComponent.chargeDetails.value,
                localExpenseDetails:this.localExpenseDetailsComponent.chargeDetails.value,
                overseasIncomeDetails:this.overseasIncomeDetailsComponent.chargeDetails.value,
                overseasExpenseDetails:this.overseasExpenseDetailsComponent.chargeDetails.value
              }
    if(this.mapChargeSegmentForm.valid && this.localIncomeDetailsComponent.chargeDetails.valid &&  
        this.localExpenseDetailsComponent.chargeDetails.valid && this.overseasExpenseDetailsComponent.chargeDetails.valid &&
        this.overseasIncomeDetailsComponent.chargeDetails.valid){
          this.isEditedData=true;
          if(this.id.value && this.mapChargeSegmentForm.dirty){
              this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT);
          }
          else {
            this.openDailog(Message.SAVE_OPEN_DAILOG);
          } 
    }
  }

  private saveMapChargeToBusinessSegment(){
    let method=(this.id.value)?'put':'post';
    let message=(this.id.value)?'updated':'saved';
    this.service[method](Api.MAP_CHARGE_TO_BUSINESS_SEGMENT,this.data).subscribe(res => {
      if(res){
        this.logger.info('Map Charge to Business Segment Save Res',res);
        this.utilityService.notifier(`Map Charge to Business Segment ${message} Successfully`,'success');
        this.router.navigate([APP_ROUTES.MAP_CHARGE_TO_BUSINESS_SEGMENT_LIST]);
      }
    });
  }

  onCancel(){
    if(this.mapChargeSegmentForm.dirty || this.localIncomeDetailsComponent.chargeDetailForm.dirty ||  
      this.localExpenseDetailsComponent.chargeDetailForm.dirty || this.overseasExpenseDetailsComponent.chargeDetailForm.dirty ||
      this.overseasIncomeDetailsComponent.chargeDetailForm.dirty){
      this.isEditedData=false;
      this.id.value?this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT):this.openDailog(Message.CANCEL_OPEN_DAILOG);
    }else{
      this.router.navigate([APP_ROUTES.MAP_CHARGE_TO_BUSINESS_SEGMENT_LIST]);
    }
  }

  openDeactivateForm(e:MatSlideToggleChange){
    let data={id:this.id.value,message:'Map Charge to Business Segment',api:Api.DEACTIVATE_MAP_CHARGE_TO_BUSINESS_SEGMENT,route:APP_ROUTES.MAP_CHARGE_TO_BUSINESS_SEGMENT_LIST}
    const dailogRef=this.dailog.open(DeactivateComponent,{data:data});
    dailogRef.afterClosed().subscribe(value => {
      this.checked = !this.checked;
    })
  }

  openReactivateForm(e:MatSlideToggleChange){
    let data={id:this.id.value,message:'Map Charge to Business Segment',api:Api.REACTIVATE_MAP_CHARGE_TO_BUSINESS_SEGMENT,route:APP_ROUTES.MAP_CHARGE_TO_BUSINESS_SEGMENT_LIST}
    const dailogRef=this.dailog.open(ReactivateComponent,{data:data});
    dailogRef.afterClosed().subscribe(value => {
      this.checked = !this.checked;
    })
  }


  private getMapChargeBusinessSegmentById(){
    this.service.get(Api.MAP_CHARGE_TO_BUSINESS_SEGMENT+'/'+this.id.value).subscribe(res => {
      if(res){
        this.logger.info('Map Charge to Business Segment By Id Res',res);
        this.showStatus=this.getStatus(res);
        
        this.mapChargeBusinessSegmentData=res;
        this.mapChargeSegmentForm.patchValue(res);
        this.resLocalIncomeDetails=res.localIncomeDetails;
        this.resLocalExpenseDetails=res.localExpenseDetails;
        this.resOverseasExpenseDetails=res.overseasExpenseDetails;
        this.resOverseasIncomeDetails=res.overseasIncomeDetails;
        this.patchSezIncomeDetails(res.sezIncomeDetails);
        if(res.submittedForApproval || res.status==='DEACTIVATED'){
          this.mapChargeSegmentForm.disable();
          this.disableSubmit=true;
        }
      }
    });
  }

  private patchSezIncomeDetails(res) {
    this.sezIncomeDetails.clear();
    res.forEach((element,index) => {
      element.show=element.activeDetail?true:false;
      this.sezIncomeDetails.push(this.chargeForm(element));
      this.patchChargeNameToSezDetails(element,index);
      this.patchSacNameToSezDetails(element,index);
      this.sezDetailsDataSource.next(this.sezIncomeDetails.controls);
    });
  }

  private getStatus(data: any) {
    if (data.status == "APPROVED" && !data.submittedForApproval && this.deactivatePermission) {
      this.showDeactivateToggle=true;
      return null;
    }
    else if (data.status == "DEACTIVATED" && !data.submittedForApproval) {
      this.showReactivateToggle=true;
      return "Deactivated...";
    } else {
      return this.utilityService.getApprovalMessage({status:data.status,
        submittedForApproval: data.submittedForApproval,
        deactivationWefDate: data.deactivate?.deactivationWefDate,
        reactivationWefDate: data.reactivate?.reactivationWefDate});
    }
  }

  getStates(){
    this.service.get(Api.STATE_FOR_DD).forEach(res => {
       if(res){
         this.states=res;
         this.filteredStates.next(this.states);
       }
    });
  }

  getSegments(){
    this.segmentCriteria['active.equals']=true;
    this.service.get(Api.BUSINESS_SEGMENT_FOR_DD,this.segmentCriteria).forEach(res => {
       if(res){
         this.segments=res;
         this.filteredSegments.next(this.segments);
       }
    });
  }

  getLedgers(){
    this.legderCriteria.activeFlag=true;
    this.service.get(Api.LEDGER_FOR_DD,this.legderCriteria).subscribe(res => {
      if(res){
        this.ledgers=res;
        this.filteredLedgers.next(this.ledgers);
      }
    })
  }

  getPreviousEntries(){
    this.criteria['active.equals']=true;
    this.service.get(Api.MAP_CHARGE_BUSINESS_SEGMENT_FOR_COPY).subscribe(res => {
      if(res){
        this.previousEntries=res;
        this.filteredPreviousEntries.next(this.previousEntries);
      }
    });
  }

  getCharges(){
    this.chargeCriteria['active.equals']=true;
    this.service.get(Api.CHARGE_FOR_DD,this.chargeCriteria).subscribe(res => {
      if(res){
        this.charges=res;
        this.filteredCharges.next(this.charges);
        this.patchChargeListValueToSezDetails(); 
      }
    })
  }

  private patchChargeListValueToSezDetails(){
     this.sezIncomeDetails.value.forEach((element,index) => {
       this.sezIncomeDetails.at(index).get('chargeList').setValue(this.charges);
       this.patchChargeNameToSezDetails(element,index);
     });
  }

  private patchChargeNameToSezDetails(element,index){
     let chargeById=_.findWhere(this.charges,{parentId:element.chargeId});
     this.sezIncomeDetails.at(index).get('chargeName').setValue(chargeById?.name);
  }

  getGstList(){
    this.service.get(Api.GST_FOR_DD).subscribe(res => {
      if(res){
        this.gstList=res;
        this.filteredSAC.next(this.gstList);
        this.patchSacListValueToSezDetails(); 
      }
    })
  }

  private patchSacListValueToSezDetails(){
    this.sezIncomeDetails.value.forEach((element,index) => {
      this.sezIncomeDetails.at(index).get('sacList').setValue(this.gstList);
      this.patchSacNameToSezDetails(element,index);
    });
 }

 private patchSacNameToSezDetails(element,index){
   let sacById=_.findWhere(this.gstList,{id:element.sacId});
   this.sezIncomeDetails.at(index).get('sacName').setValue(sacById.name);
 }

  getChargeTypeMechanism(){
    this.service.get(Api.CHARGE_TYPE_MECHANISM).subscribe(res => {
      if(res){
        this.chargeTypeMechanismList=res;
      }
    })
  }

  public getAllPermissions(){
    let permissionCodes=[PermissionKey.MAP_CHARGE_TO_BUSINESS_SEGMENT_ADD_PERMISSION,PermissionKey.MAP_CHARGE_TO_BUSINESS_SEGMENT_DEACTIVATE_PERMISSION,
                         PermissionKey.MAP_CHARGE_TO_BUSINESS_SEGMENT_EDIT_PERMISSION,PermissionKey.MAP_CHARGE_TO_BUSINESS_SEGMENT_REACTIVATE_PERMISSION];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.MAP_CHARGE_TO_BUSINESS_SEGMENT);
    this.reactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.MAP_CHARGE_TO_BUSINESS_SEGMENT_REACTIVATE_PERMISSION})?.show?true:false;
    this.deactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.MAP_CHARGE_TO_BUSINESS_SEGMENT_DEACTIVATE_PERMISSION})?.show?true:false;
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.MAP_CHARGE_TO_BUSINESS_SEGMENT_EDIT_PERMISSION})?.show?true:false;
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.MAP_CHARGE_TO_BUSINESS_SEGMENT_ADD_PERMISSION})?.show?true:false;
  }

  ngAfterViewChecked(){
    this.changerDetectorRef.detectChanges();
  }

  get id(){ return this.mapChargeSegmentForm.get('id');}
  get segmentId(){ return this.mapChargeSegmentForm.get('segmentId');}
  get previousEntryId(){ return this.mapChargeSegmentForm.get('previousEntryId');}
  get stateId(){ return this.mapChargeSegmentForm.get('stateId');}
  get localIncomeLedgerId(){ return this.mapChargeSegmentForm.get('localIncomeLedgerId');}
  get localExpenseLedgerId(){ return this.mapChargeSegmentForm.get('localExpenseLedgerId');}
  get overseasExpenseLedgerId(){ return this.mapChargeSegmentForm.get('overseasExpenseLedgerId');}
  get overseasIncomeLedgerId(){ return this.mapChargeSegmentForm.get('overseasIncomeLedgerId');}
  get sezIncomeLedgerId(){ return this.mapChargeSegmentForm.get('sezIncomeLedgerId');}
  get showSezIncomeDetails(){ return this.mapChargeSegmentForm.get('showSezIncomeDetails');}
  get showLocalIncomeDetails(){ return this.mapChargeSegmentForm.get('showLocalIncomeDetails');}
  get showLocalExpenseDetails(){ return this.mapChargeSegmentForm.get('showLocalExpenseDetails');}
  get showOverseasIncomeDetails(){ return this.mapChargeSegmentForm.get('showOverseasIncomeDetails');}
  get showOverseasExpenseDetails(){ return this.mapChargeSegmentForm.get('showOverseasExpenseDetails');}
  get sezIncomeDetails(){ return <FormArray>this.mapChargeSegmentForm.get('sezIncomeDetails');}
}
